<template>
  <b-container fluid class="login text-center">
    <b-row class="logo" :class="{expanded: logoExpanded}" align-v="center">
      <b-col>
        <img src="@/assets/bing8-logo.png" alt="">
      </b-col>
    </b-row>
    <b-row align-h="center" v-if="setUsernameDialog">
        <b-col md="5">
          <b-card sub-title="Crea tu nombre de Usuario">
            <b-form-group>
              <b-form-input v-model="username" placeholder=""></b-form-input>
            </b-form-group>
            <b-button class="w-100" @click="addUsernameAndContinue">Continuar</b-button>
            <b-alert class="username-alert" v-if="wrongUsername" variant="danger" show>
              {{wrongUsername}}
            </b-alert>
          </b-card>
        </b-col>
    </b-row>
    <b-row align-h="center" class="social-login">
      <b-col id="firebaseui-auth-container"></b-col>
    </b-row>
    <b-row align-h="center" v-if="!setUsernameDialog">
      <b-col md="5">
        <!-- <b-button class="w-100" @click="toggleUserPassLogin">{{ userPassButtonContent }}</b-button> -->
        <!-- <b-button variant="light" v-if="!userPassVisible" @click="socialLogin" class="w-100">
          <span class="google-button__icon">
            <svg viewBox="0 0 366 372" xmlns="http://www.w3.org/2000/svg"><path d="M125.9 10.2c40.2-13.9 85.3-13.6 125.3 1.1 22.2 8.2 42.5 21 59.9 37.1-5.8 6.3-12.1 12.2-18.1 18.3l-34.2 34.2c-11.3-10.8-25.1-19-40.1-23.6-17.6-5.3-36.6-6.1-54.6-2.2-21 4.5-40.5 15.5-55.6 30.9-12.2 12.3-21.4 27.5-27 43.9-20.3-15.8-40.6-31.5-61-47.3 21.5-43 60.1-76.9 105.4-92.4z" id="Shape" fill="#EA4335"/><path d="M20.6 102.4c20.3 15.8 40.6 31.5 61 47.3-8 23.3-8 49.2 0 72.4-20.3 15.8-40.6 31.6-60.9 47.3C1.9 232.7-3.8 189.6 4.4 149.2c3.3-16.2 8.7-32 16.2-46.8z" id="Shape" fill="#FBBC05"/><path d="M361.7 151.1c5.8 32.7 4.5 66.8-4.7 98.8-8.5 29.3-24.6 56.5-47.1 77.2l-59.1-45.9c19.5-13.1 33.3-34.3 37.2-57.5H186.6c.1-24.2.1-48.4.1-72.6h175z" id="Shape" fill="#4285F4"/><path d="M81.4 222.2c7.8 22.9 22.8 43.2 42.6 57.1 12.4 8.7 26.6 14.9 41.4 17.9 14.6 3 29.7 2.6 44.4.1 14.6-2.6 28.7-7.9 41-16.2l59.1 45.9c-21.3 19.7-48 33.1-76.2 39.6-31.2 7.1-64.2 7.3-95.2-1-24.6-6.5-47.7-18.2-67.6-34.1-20.9-16.6-38.3-38-50.4-62 20.3-15.7 40.6-31.5 60.9-47.3z" fill="#34A853"/></svg>
          </span>
          <span class="google-button__text">Entrar con Google</span>
        </b-button>
        <router-link v-if="!userPassVisible" :to="{ path: '/sign-up', query: {redirect: $route.query.redirect || '/rooms-list'}}">
          <b-button variant="outline-light" class="w-100 sign-up">Crea tu cuenta aquí</b-button>
        </router-link>
        <b-collapse v-model="userPassVisible" class="collapse">
          <b-card>
            <b-form @submit="login">
              <b-form-group>
                <b-form-input type="email" v-model="email" required placeholder="Email"></b-form-input>
              </b-form-group>
              <b-form-group>
                <b-form-input v-model="password" required type="password" placeholder="Contraseña"></b-form-input>
              </b-form-group>
              <b-button type="submit" class="w-100" :disabled="loginActive">ENTRAR</b-button>
              <b-alert class="username-alert" v-if="loginError" variant="danger" show>
                {{loginError}}
              </b-alert>
            </b-form>
          </b-card>
          <router-link :to="{ path: '/sign-up', query: {redirect: $route.query.redirect || '/rooms-list'}}">
            <b-button variant="outline-light" class="w-100 sign-up">Crea tu cuenta aquí</b-button>
          </router-link>
        </b-collapse> -->
      </b-col>
    </b-row>
    <b-row align-v="center" align-h="center" class="overlay" v-if="loading">
      <b-spinner variant="dark" type="grow" label="Loading..."></b-spinner>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';
import  * as firebaseui from 'firebaseui';

const fb = require("../firebaseConfig.js");
export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      username: '',
      setUsernameDialog: false,
      wrongUsername: false,
      userPassVisible: false,
      userPassButtonContent: "Entrar con Usuario y Contraseña",
      userPassVButtonVariant: "secondary",
      loading: false,
      logoExpanded: true,
      loginError: false,
      loginActive: false
    }
  },
  computed: mapState(['currentUser']),
  mounted() {
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(fb.auth());
    }
    var uiConfig = {
      // signInFlow: "popup",
      signInOptions: [
        fb.auth.FacebookAuthProvider.PROVIDER_ID,
        fb.auth.GoogleAuthProvider.PROVIDER_ID,
        fb.auth.EmailAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccessWithAuthResult: (result) => {
          this.socialSignUp(result);
        }
      }
    };
    ui.start("#firebaseui-auth-container", uiConfig);
  },
  methods: {
    toggleUserPassLogin() {
      if (this.userPassVisible) {
        this.userPassButtonContent = "Entrar con Usuario y Contraseña";
        this.logoExpanded = true;
      } else {
        this.userPassButtonContent = "Volver";
        this.logoExpanded = false;
      }
      this.userPassVisible = !this.userPassVisible
    },
    login(e) {
      e.preventDefault();
      this.loginActive = true;
      fb.auth()
      .signInWithEmailAndPassword(this.email, this.password)
      .then((result) => {
        console.log(result.user);
        fb.usersCollection.doc(result.user.uid).get()
        .then((user) => {
          if (user.exists) {
            this.$store.commit('setCurrentUser', user.data());
            this.$router.push(this.$route.query.redirect || '/rooms-list');
          } else {
            alert("El usuario no existe")
          }
          this.loginActive = false;
        });
      })
      .catch((err) => {
        if (err.code == "auth/user-not-found" || err.code == "auth/wrong-password") {
          this.loginError = "Usuario o contraseña incorrectos";
        } else if (err.code == "auth/invalid-email") {
          this.loginError = "El formato del Email es incorrecto";
        } else {
          console.error(err)
          alert(err.message);
        }
        this.loginActive = false;
      });
    },
    addUsernameAndContinue() {
      if (this.username.length < 3) {
        this.wrongUsername = "El nombre de usuario debe tener al menos 3 caracteres";
      } else {
        fb.usersCollection.where("username", "==", this.username).get()
        .then((querySnapshot) => {
          if (querySnapshot.size > 0) {
            this.wrongUsername = "Este nombre de usuario ya existe";
          } else {
            fb.usersCollection.doc(this.currentUser.uid).update({
              username: this.username
            })
            .then(() => {
              this.$store.commit('setCurrentUser', {...this.currentUser, username: this.username});
              this.$router.push(this.$route.query.redirect || '/rooms-list');
            })
          }
        })
        .catch((err) => {
          console.error("Error getting username availability", err);
        });
      }
    },
    socialSignUp(result) {
      const user = {
        uid: result.user.uid,
        displayName: result.user.displayName,
        email: result.user.email
      }
      fb.usersCollection.doc(result.user.uid).get()
      .then((doc) => {
        if (!doc.exists) {
          fb.usersCollection.doc(result.user.uid).set(user)
          .then(() => {
            this.checkUsernameAndContinue(user)
          })
          .catch((err) => {
            this.loading = false;
            console.error(err);
            alert('Error creating user');
          });
        } else {
          fb.usersCollection.doc(result.user.uid).update(user)
          .then(() => {
            this.checkUsernameAndContinue(doc.data());
          })
          .catch((err) => {
            this.loading = false;
            console.error(err);
            alert('Error updating user info');
          });
        }
      })
      .catch((err) => {
        this.loading = false;
        console.error(err);
        alert('Oops. ' + err.message);
      });
    },
    socialLogin() {
      this.loading = true;
      const provider = new fb.auth.GoogleAuthProvider();
      fb.auth().signInWithPopup(provider).then((result) => {
        this.socialSignUp(result);
      })
      .catch((err) => {
        this.loading = false;
        console.error(err);
        alert('Oops. ' + err.message);
      });
    },
    facebookLogin() {
      this.loading = true;
      const provider = new fb.auth.FacebookAuthProvider();
      fb.auth().signInWithPopup(provider).then((result) => {
        this.socialSignUp(result);
      })
      .catch((err) => {
        this.loading = false;
        console.error(err);
        alert('Oops. ' + err.message);
      });
    },
    checkUsernameAndContinue(user) {
      this.$store.commit('setCurrentUser', user);
      if (!user.username || user.username.length === 0) {
        console.warn("User doesn't have username");
        this.setUsernameDialog = true;
        this.logoExpanded = false;
        this.loading = false;
      } else {
        this.$router.push(this.$route.query.redirect || '/rooms-list');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  position: absolute;
  background-color: var(--primary);
  height: 100%;
  display: flex;
  flex-direction: column;
}
.sign-up, .collapse {
  margin-top: 20px;
}
.username-alert {
  margin-top: 20px;
}
.social-button img {
  width: 100%;
}
.google-button__icon {
  display: inline-block;
  vertical-align: middle;
  margin: -4px 10px 0 0;
  width: 18px;
  box-sizing: border-box;
}
.overlay {
  position: absolute;
  margin: 0;
  padding: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.logo {
  height: 20%;
  img {
    width: 40%;
    max-width: 200px;
  }
  transition: height 0.3s;
}
.logo.expanded {
  height: 40%;
}
button {
  margin-top: 9px;
}
</style>